import { OrderDto, OrderRestaurantDto, PreparationStatutCommandes, RestaurantServiceValues, ScorpOrderDto, StatutCommandes } from '@timechef/core/api';

export interface ItemsByPeriod<T> {
  period: PeriodEnum;
  items: T[];
}

export enum PeriodEnum {
  Today = 'Today',
  Yesterday = 'Yesterday',
  ThisWeek = 'ThisWeek',
  LastWeek = 'LastWeek',
  Previously = 'Previously',
  Coming = 'Coming',
}

export interface PageInfo {
  hasMore: boolean;
  currentPageIndex: number;
}

export interface PageInfoWithData<T> extends PageInfo {
  data: T[];
}

export interface HistoryItem {
  date: string;
  id: number;
  showHours: boolean;
  amount: number;
  scorp?: ScorpOrderDto;
  restaurant?: OrderRestaurantDto;
  status?: StatutCommandes;
  preparationStatus?: PreparationStatutCommandes;
  service?: RestaurantServiceValues;
}

export interface Order extends OrderDto {
  isCc: boolean;
  isCollected: boolean;
}
